export enum DeliveryOrderColumnId {
    ORDER = 'Orders.List.Order',
    STATUS = 'Orders.List.Status',
    CUSTOMER = 'Orders.List.Customer',
    PICKUP_FROM = 'Orders.List.PickUpFrom',
    ORDERED = 'Orders.List.Ordered',
    TOTAL = 'Orders.List.Total',
    SERVICE_PROVIDER = 'Orders.List.Provider',
    PICKUP = 'Orders.List.DriverPickUp',
    DROPOFF = 'Orders.List.DropOff',
    DISTANCE = 'Orders.List.Distance',
    DRIVER = 'Orders.List.Driver',
    WARNING = 'Orders.List.Warning',
    MANAGER_NOTES = 'Orders.List.ManagerNotes',
}
